"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZINDEX = exports.NiceUiSizes = void 0;
var NiceUiSizes;
(function (NiceUiSizes) {
    NiceUiSizes[NiceUiSizes["BlogContentMaxWidth"] = 720] = "BlogContentMaxWidth";
    NiceUiSizes[NiceUiSizes["SiteWidth"] = 1300] = "SiteWidth";
    NiceUiSizes[NiceUiSizes["MinSiteWidth"] = 320] = "MinSiteWidth";
    NiceUiSizes[NiceUiSizes["SitePadding"] = 32] = "SitePadding";
    NiceUiSizes[NiceUiSizes["TopNavHeight"] = 64] = "TopNavHeight";
    NiceUiSizes[NiceUiSizes["NavHeight"] = 58] = "NavHeight";
    NiceUiSizes[NiceUiSizes["SidebarWidth"] = 300] = "SidebarWidth";
    NiceUiSizes[NiceUiSizes["FooterHeight"] = 290] = "FooterHeight";
})(NiceUiSizes || (exports.NiceUiSizes = NiceUiSizes = {}));
var ZINDEX;
(function (ZINDEX) {
    ZINDEX[ZINDEX["TOP_NAV"] = 1000] = "TOP_NAV";
    ZINDEX[ZINDEX["SIDEBAR"] = 1001] = "SIDEBAR";
    ZINDEX[ZINDEX["PROGRESS"] = 2000] = "PROGRESS";
    ZINDEX[ZINDEX["MODAL"] = 4000] = "MODAL";
    ZINDEX[ZINDEX["TOAST"] = 5000] = "TOAST";
    ZINDEX[ZINDEX["CONTEXT"] = 75000] = "CONTEXT";
    ZINDEX[ZINDEX["TOOLTIP"] = 10000] = "TOOLTIP";
    ZINDEX[ZINDEX["CURSOR"] = 1000000] = "CURSOR";
})(ZINDEX || (exports.ZINDEX = ZINDEX = {}));
